import { useMemo, useState } from 'react';
import { ControlOption } from '@shared/components/filter/types';
import { MBSearchBar } from '@shared/components/searchBar';
import { grid } from '@shared/styles';
import { ListItem } from './ListItem';
import styles from './List.module.css';

interface ListProps {
  options: ControlOption[];
  onSelect(item: ControlOption): void;
  showSearch?: boolean;
  selected?: ControlOption;
  disabledItems?: string[];
}

export function List({ options, onSelect, showSearch = true, selected, disabledItems }: ListProps) {
  const [filter, setFilter] = useState('');

  const filteredOptions = useMemo(
    () => options.filter(option => option.label.toLowerCase().includes(filter.toLowerCase())),
    [filter, options],
  );

  return (
    <>
      {showSearch && (
        <MBSearchBar value="" onChangeText={setFilter} style={[{ marginBottom: grid(1) }]} />
      )}
      <ul className={styles.list}>
        {filteredOptions.map(option => (
          <ListItem
            key={option.id}
            icon={option.icon}
            label={option.label}
            isSelected={selected?.id === option.id}
            onClick={() => onSelect(option)}
            isDisabled={disabledItems?.includes(option.id)}
          />
        ))}
      </ul>
    </>
  );
}
